export *from './embedded-login.component';
export *from './login.component';
export *from './password-change.component';
export * from './registration/register.component';
export * from './registration/registration-form.component';
export * from './registration/activation-form.component';
export * from './twoFactorSetup.component';
export * from './twoFactorValidate.component';
export * from './twoFactorCertificate.component';
export * from './forgotPassword.component';
export * from './resetPassword.component';



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/index.ts